// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient,HttpParams, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LoginResponse } from '../models/user';
import { Router } from '@angular/router';
import * as actionSession from '../../core/actions/session.actions';
import { Store } from '@ngrx/store';
import { User } from '../models/user';
import { BaseService } from './base.service';


@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService {

  // Verify user credentials on server to get token
  getAll(sortField: string = 'name', sortOrder: number = 2, filters: any,
    first: number, rows: number): Observable<HttpResponse<User[]>> {

      let params = new HttpParams()
        .set('sort',((sortOrder===1) ? '' : '-') + sortField)
        .set('page', ((first/rows)+1).toString())
        .set('per-page', rows.toString());
          for (let a in filters) {
      params = params.set(a,filters[a].value);
    }
    return this.http
      .get<User[]>(this.basePath + '/v1/users', {params: params,  observe: 'response'})
      .pipe(
        catchError(this.handleError)
      );
  }
  get(id: number): Observable<User> {
    return this.http
      .get<User>(this.basePath + '/v1/users/' + id + "?expand=userProfile,roles")
      .pipe(
        catchError(this.handleError)
      );
  }
  save(user: any): Observable<User> {

    if (user.id < 0 ) {
      return this.http
        .post<User>(this.basePath + '/v1/users?expand=', user)
        .pipe(
          catchError(this.handleError)
        );

    }
    console.log('save',user);
    return this.http
      .put<User>(this.basePath + '/v1/users/' + user.id+ "?expand=userProfile,roles", user)
      .pipe(
        catchError(this.handleError)
      );
  }
}
